import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAnalytics } from "../Hooks/usePageChange";
import Constants, {
  EditProfileMenu,
  loginFrom,
  EventName,
  EventKeys,
} from "../Constants/constants";
import RouteSegments, { RouteHelper } from "../Routes/RouteSegment";
import OverflowToolTip from "./utils/OverflowTooltip";
import CloseIcon from "../Images/Group 761@2x.png";
import {
  MatchesCall,
  ViewPhoeNum,
  ViewHoroscope,
  ChatProfile,
  WhatsappProfile,
  ChatBox,
  MatchesGroupIcon,
  cancellgrayicon,
} from "../Components/Kalyanlite/assets/images";
import { useNavigate } from "react-router";

// import * as Images from './../assets/images';

    // Import the i18n instance


const PaymentCLCPopup = ({
  closePopup,
  message,
  title,
 matchesCount,
 popupModel,
 onPayNow,
 bannerFooter
}) => {
  const closePopupRef = useRef();
  const { onClickTrack } = useAnalytics();
  const navigate = useNavigate();

  const { t:trans } = useTranslation();

  const popupMessageMap = {
  "Matches count": "Become a paid member and start calling your matches today.",
  "Requests Count": "Buy a calling pack and get the details you want instantly.",
  "Messages count": "Become a paid member and start calling your matches and connect personally.",
  "Profile Views count": "Become a paid member and start calling your matches and connect personally.",
};

const popupMessage = popupMessageMap[popupModel] || "Buy a calling Pack and connect instantly !";

 const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const formattedMessage = () => {
  const match = message.match(/(\d+)/); // extract the first number
  if (match) {
    const number = match[0];
    const parts = message.split(number);
    return (
      <>
        {parts[0]}
        <span className="text-red-600 font-bold">{number}</span>
        {parts[1]}
      </>
    );
  }
  return message;
};
const hideHoroscope = popupModel;

  return (
    <div className={`flex justify-center items-center md:items-center overflow-x-hidden fixed inset-0 z-50 outline-none focus:outline-none ${title == trans('clcprivacy_popup.add_photo_with_privacy_options') && windowWidth < 500 ? 'overflow-y-hidden ' : 'overflow-y-auto bg-opacityblack '}`}>
      <div
        // className={`relative modal-container md:my-6 md:mx-6 ${isViewProfile ? "lg:w-[23vw] md:w-[42vw] w-[71vw]" :"lg:w-[40vw] md:w-[70vw] w-[90vw]"}`}
        className={`relative  modal-container md:my-6 md:mx-6 ${title == trans('clcprivacy_popup.add_photo_with_privacy_options') && windowWidth < 500 ? 'w-full h-full lg:w-[58vw] md:w-[70vw] pt-[5rem]' : 'w-[90vw] lg:w-[36vw] md:w-[70vw] '}`}
        ref={closePopupRef}
      >
        <div className="">
          {title == trans('clcprivacy_popup.add_photo_with_privacy_options') && windowWidth < 500 ? '' :
            <button
              className=" bg-transparent z-40 border-0 text-black  absolute md:top-[-.5rem] md:left-[-0.4rem] lg:left-[-0.4rem] lg:top-[-0.4rem]"
              onClick={() => {
                onClickTrack(EventName.V3_Site_Payment_CLC_Popup_Close_Button);
    closePopup();
  }}
            >
              <img className="w-5 h-5 " src={CloseIcon} alt="" />
            </button>}
        </div>
        <div className={`border-0 shadow-lg relative mr-[0.5rem] flex flex-col w-full bg-white outline-none focus:outline-none rounded-[20px]`}>
          <div className={`px-4 pb-4 sm:p-6 sm:pb-4 rounded-2xl relative py-8 flex-auto ${title == trans('clcprivacy_popup.add_photo_with_privacy_options') && windowWidth < 500 ? 'pt-[1.5rem]' : 'pt-5 '}`}>
            <div className={`flex flex-col justify-center mb-5 mx-[1rem] ${title == trans('clcprivacy_popup.add_photo_with_privacy_options') && windowWidth < 500 ? '' : 'items-center '}`}>
              <h2 className='text-center text-red-600 font-medium text-[20px]'>{title}</h2>
               <p className='text-center sm:max-w-[70%] text-[20px] text-[#000000] font-bold pt-2'>{bannerFooter}</p> 
<div className="pt-4 pb-4">
              <div className='relative flex justify-center items-center'>
                                      <img className='h-[3rem] xl:h-[4rem] whitespace-nowrap' src={MatchesCall} alt='' />
                                      {/* <div
                                          className={`absolute top-0 right-0 bg-yellow-400 text-black text-[12px] font-bold rounded-full w-[1.5rem] h-[1.5rem] flex items-center justify-center shadow-md`}
                                      > */}
                                  {matchesCount > 2 && (
                                      <div className="absolute xl:top-0 xl:right-0 top-0 right-0 bg-yellow-400 text-black text-[12px] font-bold rounded-full min-w-[1.5rem] h-[1.5rem] flex items-center justify-center shadow-md p-2">
                                          {matchesCount} 
                                          
                                      </div>
                                  )}
                                  </div>
                                  </div>

<h2 className='text-left md:text-center sm:max-w-[88%] text-[#000000] font-medium text-[18px]'>{formattedMessage()}</h2>


{/* <div className="grid grid-cols-2 max-w-md mx-auto mt-10">
  <div className=" text-center p-6 rounded-lg flex">
    <img className='h-[3rem] xl:h-[4rem]' src={ViewPhoeNum} alt='' />
    <span className="whitespace-nowrap flex justify-center items-center pl-2">View phone numbers</span>
  </div>
  <div className=" text-center p-6 rounded-lg flex pl-12">
    <img className='h-[3rem] xl:h-[4rem]' src={ViewPhoeNum} alt='' />
    <span className="whitespace-nowrap flex justify-center items-center pl-2">View phone numbers</span>
  </div>
  <div className="text-center p-6 rounded-lg flex">
    <img className='h-[3rem] xl:h-[4rem]' src={ViewPhoeNum} alt='' />
    <span className="whitespace-nowrap flex justify-center items-center pl-2">View phone numbers</span>
    </div>
  <div className="text-center p-6 rounded-lg flex pl-12">
    <img className='h-[3rem] xl:h-[4rem]' src={ViewPhoeNum} alt='' />
    <span className="whitespace-nowrap flex justify-center items-center pl-2">View phone numbers</span>
  </div>
</div> */}

<div className="max-w-[600px] mx-auto">
  <p className='text-left text-[18px] leading-snug break-words text-[#646464] pt-4'>{popupMessage}</p>
{/* <div className='md:grid  md:grid-cols-2  gap-x-[6rem] gap-y-4 mt-4 md:mt-6'>
<div className='flex items-center gap-2'>
                            <img className='h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain' src={ViewPhoeNum} alt='' />
                            <p className='font-semibold text-[13px] xl:text-[12px] text-[#646464]'>View phone numbers</p>
                            
                        </div>
                        
                        <div className='flex items-center gap-2'>
                            <img className='h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain' src={ViewHoroscope} alt='' />
                            <p className='font-semibold text-[13px] xl:text-[12px] text-[#646464]'>View horoscopes</p>
                        </div>
                          <div className="col-span-2 flex items-center justify-between">
    <div className="w-[45%] h-[1.5px] bg-gray-300 opacity-60 rounded shadow-sm"></div>
    <div className="w-[45%] h-[1.5px] bg-gray-300 opacity-60 rounded shadow-sm"></div>
  </div>

                        <div className='flex items-center gap-2'>
                            <img className='h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain' src={ChatProfile} alt='' />
                            <p className='font-semibold text-[13px] xl:text-[12px] text-[#646464]'>Chat with profiles</p>
                        </div>
                        <div className='flex items-center gap-2'>
                            <img className='h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain' src={WhatsappProfile} alt='' />
                            <p className='font-semibold text-[13px] xl:text-[12px] text-[#646464]'>Get matches on whatsApp!</p>
                        </div>
                        </div> */}


<div className="grid md:grid-cols-2 gap-x-[4rem] gap-y-4 mt-4 md:mt-6">
  {/* 1 */}
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <img className="h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain" src={ViewPhoeNum} alt="" />
      <p className="font-semibold text-[13px] xl:text-[12px] text-[#646464]">View phone numbers</p>
    </div>
    <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
  </div>

  {/* 2 */}
  {/* {hideHoroscope ==='Profile Views count' ? (
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <img className="h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain" src={ViewHoroscope} alt="" />
      <p className="font-semibold text-[13px] xl:text-[12px] text-[#646464]">View horoscopes</p>
    </div>
    <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
  </div>
  ) : (

    <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <img className="h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain" src={ChatProfile} alt="" />
      <p className="font-semibold text-[13px] xl:text-[12px] text-[#646464]">Chat with profiles</p>
    </div>
    <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
  </div>
  )} */}

  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <img className="h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain" src={ViewHoroscope} alt="" />
      <p className="font-semibold text-[13px] xl:text-[12px] text-[#646464]">View horoscopes</p>
    </div>
    <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
  </div>


  {/* Center line (only desktop) */}
  
  <div className="hidden md:flex col-span-2 items-center justify-between">
    <div className="w-[45%] h-[1.5px] bg-gray-300 opacity-60 rounded shadow-sm"></div>
    <div className="w-[45%] h-[1.5px] bg-gray-300 opacity-60 rounded shadow-sm"></div>
  </div>


  {/* 3 */}
  {/* {hideHoroscope ==='Profile Views count' && (
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <img className="h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain" src={ChatProfile} alt="" />
      <p className="font-semibold text-[13px] xl:text-[12px] text-[#646464]">Chat with profiles</p>
    </div>
    <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
  </div>
  )} */}

  
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <img className="h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain" src={ChatProfile} alt="" />
      <p className="font-semibold text-[13px] xl:text-[12px] text-[#646464]">Chat with profiles</p>
    </div>
    <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
  </div>
 

  {/* 4 */}
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <img className="h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain" src={WhatsappProfile} alt="" />
      <p className="font-semibold text-[13px] xl:text-[12px] text-[#646464]">Get matches on WhatsApp!</p>
    </div>
    {/* <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div> */}
  </div>
</div>



                    </div>


            </div>
           
                  <button
                 
                    onClick={onPayNow}
                    className={`mx-auto flex items-center cursor-pointer justify-center my-1 h-[1.5rem] text-white bg-[#D10A11] border border-[#D10A11] md:px-[2.3rem] lg:px-[2.8rem] whitespace-nowrap rounded-[50px] font-segoe font-semibold py-[1rem] md:py-[1rem] lg:py-4 md:text-[12px] lg:text-[12px] `}
                  >
                    <OverflowToolTip as='p' className='truncate md:w-auto w-[15rem]'>Know more</OverflowToolTip>
                  </button>
            
          </div>
        </div>
      </div>
    </div>
  );
};




const PaymentCLCBigPopup = ({
  closePopup,
  message,
  title,
 matchesCount,
 popupModel,
 onPayNow,
 bannerFooter
}) => {
  const closePopupRef = useRef();
  const { onClickTrack } = useAnalytics();
  
const navigate = useNavigate();
  const { t:trans } = useTranslation();

  const popupMessageMap = {
  "Matches count": "Become a paid member and start calling your matches today.",
  "Requests Count": "Buy a calling pack and get the details you want instantly.",
  "Messages count": "Become a paid member and start calling your matches and connect personally.",
  "Profile Views count": "Become a paid member and start calling your matches and connect personally.",
};

const popupMessage = popupMessageMap[popupModel] || "Buy a calling Pack and connect instantly !";

 const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const formattedMessage = () => {
  const match = message.match(/(\d+)/); // extract the first number
  if (match) {
    const number = match[0];
    const parts = message.split(number);
    return (
      <>
        {parts[0]}
        <span className="text-red-600 font-bold">{number}</span>
        {parts[1]}
      </>
    );
  }
  return message;
};
const hideHoroscope = popupModel ;

  return (
    <div className={` flex justify-center items-center md:items-center overflow-x-hidden fixed inset-0 z-50 outline-none focus:outline-none ${title == trans('clcprivacy_popup.add_photo_with_privacy_options') && windowWidth < 500 ? 'overflow-y-hidden ' : 'overflow-y-auto bg-opacityblack '}`}>
      <div
        // className={`relative modal-container md:my-6 md:mx-6 ${isViewProfile ? "lg:w-[23vw] md:w-[42vw] w-[71vw]" :"lg:w-[40vw] md:w-[70vw] w-[90vw]"}`}
        className="relative modal-container w-[90vw] lg:w-[50vw] md:w-[70vw] rounded-[20px] bg-gradient-to-b from-[#F9D352] to-white max-h-[90vh]"

      >
        <div className="hidden md:flex">
            <button
              className=" bg-transparent z-40 border-0 text-black  absolute md:top-[-.5rem] md:left-[-0.4rem] lg:left-[-0.4rem] lg:top-[-0.4rem]"
              onClick={() => {
                onClickTrack(EventName.V3_Site_Payment_CLC_Popup_Close_Button);
                closePopup();
              }}
            >
              <img className="w-5 h-5 " src={CloseIcon} alt="" />
            </button>
        </div>
        <div className="md:hidden">
            <button
              className="bg-transparent z-40 border-0 text-black  absolute top-[6rem] right-[3rem] top-[-0.4rem]"
              onClick={() => {
                closePopup();
              }}
            >
              <img className="w-4 h-4 " src={cancellgrayicon} alt="" />
            </button>
        </div>
        <div className={`border-0 shadow-lg relative mr-[0.5rem] flex flex-col w-full outline-none focus:outline-none rounded-[20px]  bg-gradient-to-b from-[#F9D352] to-white max-h-[90vh] lite-scrollbar overflow-hidden`}>
         <div className="rounded-scrollbar lite-scrollbar max-h-[91vh]">
          <div className={`px-4 pb-4 sm:p-6 sm:pb-4 rounded-2xl relative py-8 flex-auto ${title == trans('clcprivacy_popup.add_photo_with_privacy_options') && windowWidth < 500 ? 'pt-[1.5rem]' : 'pt-5 '}`}>
            <div className={`flex flex-col justify-center mb-5 mx-[1rem] ${title == trans('clcprivacy_popup.add_photo_with_privacy_options') && windowWidth < 500 ? '' : 'items-center '}`}>
              <h1 className='text-center xl:text-center text-[#000000] font-semibold text-[23px] text-red-600 pt-6'>{title}</h1>
              <p className='text-left xl:text-center sm:max-w-[70%] text-[23px] font-bold pt-2'>{bannerFooter}</p>
<div className="pb-4">
              <div className='relative flex justify-center items-center'>
                                      <img className='h-[12rem] xl:h-[20rem] whitespace-nowrap' src={ChatBox} alt='' />
                                      <div className="absolute bottom-[-0.5rem] z-10">
                                        <div className="relative">
                                      <img src={MatchesGroupIcon} alt="" className="h-[4.5rem] xl:h-[7rem]" />
                                      {/* <div className="absolute xl:top-0 xl:right-0 top-0 right-0 bg-yellow-400 text-black text-[12px] font-bold rounded-full w-[2rem] h-[2rem] flex items-center justify-center shadow-md">
          {matchesCount}
        </div> */}
        {matchesCount > 2 && (
         <div className="absolute xl:top-0 xl:right-0 top-0 right-0 bg-yellow-400 text-black text-[12px] font-bold rounded-full min-w-[1.5rem] h-[1.5rem] flex items-center justify-center shadow-md p-2">
                                          {matchesCount} 
                                          
                                      </div>
        )}
                                      </div>
                                      </div>
                                  </div>
                                  </div>

<div className="max-w-[740px] mx-auto">
  <h2 className='text-left sm:max-w-[88%] text-[#000000] font-medium text-[16px]'>{formattedMessage()}</h2>
  <p className='text-left text-[15px] leading-snug break-words text-[#646464] pt-2 font-semibold'>{popupMessage}</p>

<div className="grid md:grid-cols-2 gap-x-[4rem] gap-y-4 mt-4 md:mt-6 mb-[2rem]">
  {/* 1 - View phone numbers */}
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <img className="h-[3rem] w-[3rem] xl:h-[3.5rem] xl:w-[5.5rem] object-contain" src={ViewPhoeNum} alt="" />
      <div className="flex flex-col">
        <p className="font-semibold text-[14px] xl:text-[15px] text-[#646464]">View phone numbers</p>
        <p className="text-[12px] text-left text-[#646464] max-w-[288px] xl:text-[12px]">
          Get unlimited access to verified phone numbers with our calling packs. Talk directly and take the next step in your journey.
        </p>
      </div>
    </div>
    <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
  </div>

  {/* 2 - Either View Horoscope or Chat (if horoscope hidden) */}
  {/* {hideHoroscope !=='Profile Views count' ? (
    // Show "Chat with profiles" in the 2nd slot if horoscope hidden
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <img className="h-[3rem] w-[3rem] xl:h-[3.5rem] xl:w-[5.5rem] object-contain" src={ChatProfile} alt="" />
        <div className="flex flex-col">
          <p className="font-semibold text-[14px] xl:text-[15px] text-[#646464]">Chat with profiles</p>
          <p className="text-[12px] text-left text-[#646464] max-w-[288px] xl:text-[12px]">
            Chat and connect instantly with your matches. Send personalized messages to build meaningful connections.
          </p>
        </div>
      </div>
      <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
    </div>
  ) : (
    // Normal horoscope card
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <img className="h-[3rem] w-[3rem] xl:h-[3.5rem] xl:w-[5.5rem] object-contain" src={ViewHoroscope} alt="" />
        <div className="flex flex-col">
          <p className="font-semibold text-[14px] xl:text-[15px] text-[#646464]">View horoscopes</p>
          <p className="text-[12px] text-left text-[#646464] max-w-[288px] xl:text-[12px]">
            View horoscopes and find matches that align with your values, beliefs, and traditions.
          </p>
        </div>
      </div>
      <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
    </div>
  )} */}

  
     <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <img className="h-[3rem] w-[3rem] xl:h-[3.5rem] xl:w-[5.5rem] object-contain" src={ViewHoroscope} alt="" />
        <div className="flex flex-col">
          <p className="font-semibold text-[14px] xl:text-[15px] text-[#646464]">View horoscopes</p>
          <p className="text-[12px] text-left text-[#646464] max-w-[288px] xl:text-[12px]">
            View horoscopes and find matches that align with your values, beliefs, and traditions.
          </p>
        </div>
      </div>
      <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
    </div>
  

  {/* Center line */}
  
    <div className="hidden md:flex col-span-2 items-center justify-between">
      <div className="w-[45%] h-[1.5px] bg-gray-300 opacity-60 rounded shadow-sm"></div>
      <div className="w-[45%] h-[1.5px] bg-gray-300 opacity-60 rounded shadow-sm"></div>
    </div>
  

  {/* 3 - Chat (if not already moved up) */}
  {/* {hideHoroscope ==='Profile Views count' && (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <img className="h-[3rem] w-[3rem] xl:h-[3.5rem] xl:w-[5.5rem] object-contain" src={ChatProfile} alt="" />
        <div className="flex flex-col">
          <p className="font-semibold text-[14px] xl:text-[15px] text-[#646464]">Chat with profiles</p>
          <p className="text-[12px] text-left text-[#646464] max-w-[288px] xl:text-[12px]">
            Chat and connect instantly with your matches. Send personalized messages to build meaningful connections.
          </p>
        </div>
      </div>
      <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
    </div>
  )} */}

  
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <img className="h-[3rem] w-[3rem] xl:h-[3.5rem] xl:w-[5.5rem] object-contain" src={ChatProfile} alt="" />
        <div className="flex flex-col">
          <p className="font-semibold text-[14px] xl:text-[15px] text-[#646464]">Chat with profiles</p>
          <p className="text-[12px] text-left text-[#646464] max-w-[288px] xl:text-[12px]">
            Chat and connect instantly with your matches. Send personalized messages to build meaningful connections.
          </p>
        </div>
      </div>
      <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
    </div>
  

  {/* 4 - WhatsApp */}
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <img className="h-[3rem] w-[3rem] xl:h-[3.5rem] xl:w-[5.5rem] object-contain" src={WhatsappProfile} alt="" />
      <div className="flex flex-col">
        <p className="font-semibold text-[14px] xl:text-[15px] text-[#646464]">Get matches on WhatsApp!</p>
        <p className="text-[12px] text-left text-[#646464] max-w-[288px] xl:text-[12px]">
          Receive suitable profiles right on your WhatsApp.
        </p>
      </div>
    </div>
  </div>
</div>




                    </div>


            </div>
           </div>
{/* Desktop View Button */}
<div className="hidden md:flex justify-center absolute left-0 right-0 bottom-0 z-20 bg-gradient-to-t from-white via-white/80 to-transparent rounded-b-[20px] py-4">
  <button
  
     onClick={onPayNow}
    className="mx-auto flex items-center cursor-pointer justify-center my-1 h-[1.5rem] text-white bg-[#D10A11] border border-[#D10A11] px-[2.3rem] lg:px-[2.8rem] whitespace-nowrap rounded-[50px] font-segoe font-semibold py-[1rem] lg:py-4 text-[12px]"
  >
    <OverflowToolTip as='p' className='truncate md:w-auto w-[15rem]'>
      Buy a Pack and Call Now!
    </OverflowToolTip>
  </button>
</div>

          </div>
          
        </div>
      </div>

<div
        // className={`relative modal-container md:my-6 md:mx-6 ${isViewProfile ? "lg:w-[23vw] md:w-[42vw] w-[71vw]" :"lg:w-[40vw] md:w-[70vw] w-[90vw]"}`}
        className="md:hidden fixed inset-0 bg-opacity-50 z-40"
        
      >
        
        <div className={`fixed inset-0 z-50 flex items-center justify-center md:items-end md:justify-center `}>
          <div className={`md:hidden relative w-full h-full pt-[3rem] overflow-y-auto px-4 pb-6 bg-gradient-to-b from-[#F9D352] to-white lite-scrollbar`}>
            <div className={`flex flex-col mb-[4.5rem] mx-[1rem] ${title == trans('clcprivacy_popup.add_photo_with_privacy_options') && windowWidth < 500 ? '' : ''}`}>
               <div className="md:hidden absolute top-[2rem] right-[2rem] z-50">
  <button
    className="bg-transparent border-0 text-black"
    onClick={() => {
      closePopup();
    }}
  >
    <img className="w-5 h-5" src={cancellgrayicon} alt="close" />
  </button>
</div>
              
              <h1 className='text-left xl:text-center text-[#000000] font-semibold text-[23px] text-red-600'>{title}</h1>
              <p className='text-left text-[#000000] font-semibold text-[23px] pt-2'>{bannerFooter}</p>
<div className="pb-4">
              <div className='relative flex justify-center items-center'>
                                      <img className='h-[12rem] xl:h-[20rem] whitespace-nowrap' src={ChatBox} alt='' />
                                      <div className="absolute bottom-[-0.5rem] z-10">
                                        <div className="relative">
                                      <img src={MatchesGroupIcon} alt="" className="h-[4.5rem] xl:h-[7rem]" />
                                      {/* <div className="absolute xl:top-0 xl:right-0 top-0 right-0 bg-yellow-400 text-black text-[12px] font-bold rounded-full w-[1.5rem] h-[1.5rem] flex items-center justify-center shadow-md">
          {matchesCount}
        </div> */}
{matchesCount > 2 && (
         <div className="absolute xl:top-0 xl:right-0 top-0 right-0 bg-yellow-400 text-black text-[12px] font-bold rounded-full min-w-[1.5rem] h-[1.5rem] flex items-center justify-center shadow-md p-2">
                                          {matchesCount} 
                                          
                                      </div>
                                      )}
                                      </div>
                                      </div>
                                  </div>
                                  </div>

<div className="max-w-[740px] mx-auto">
  <h2 className='text-left sm:max-w-[88%] text-[#000000] font-medium text-[16px]'>{formattedMessage()}</h2>
  <p className='text-left text-[15px] leading-snug break-words text-[#646464] pt-2 font-semibold'>{popupMessage}</p>

<div className="grid md:grid-cols-2 gap-x-[4rem] gap-y-4 mt-4 md:mt-6">
  {/* 1 - View phone numbers */}
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <img className="h-[3rem] w-[3rem] xl:h-[3.5rem] xl:w-[5.5rem] object-contain" src={ViewPhoeNum} alt="" />
      <div className="flex flex-col">
        <p className="font-semibold text-[14px] xl:text-[15px] text-[#646464]">View phone numbers</p>
        <p className='text-[12px] text-left text-[#646464] max-w-[288px] xl:text-[12px]'>
          Get unlimited access to verified phone numbers with our calling packs. Talk directly and take the next step in your journey.
        </p>
      </div>
    </div>
    <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
  </div>

  {/* 2 - View horoscope or skip */}
  {/* {hideHoroscope ==='Profile Views count' && (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <img className="h-[3rem] w-[3rem] xl:h-[3.5rem] xl:w-[5.5rem] object-contain" src={ViewHoroscope} alt="" />
        <div className="flex flex-col">
          <p className="font-semibold text-[14px] xl:text-[15px] text-[#646464]">View horoscopes</p>
          <p className='text-[12px] text-left text-[#646464] max-w-[288px] xl:text-[12px]'>
            View horoscopes and find matches that align with your values, beliefs, and traditions.
          </p>
        </div>
      </div>
      <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
    </div>
  )} */}

    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <img className="h-[3rem] w-[3rem] xl:h-[3.5rem] xl:w-[5.5rem] object-contain" src={ViewHoroscope} alt="" />
        <div className="flex flex-col">
          <p className="font-semibold text-[14px] xl:text-[15px] text-[#646464]">View horoscopes</p>
          <p className='text-[12px] text-left text-[#646464] max-w-[288px] xl:text-[12px]'>
            View horoscopes and find matches that align with your values, beliefs, and traditions.
          </p>
        </div>
      </div>
      <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
    </div>

  {/* Center line only if both top rows exist */}
  {/* {hideHoroscope ==='Profile Views count' && (
    <div className="hidden md:flex col-span-2 items-center justify-between">
      <div className="w-[45%] h-[1.5px] bg-gray-300 opacity-60 rounded shadow-sm"></div>
      <div className="w-[45%] h-[1.5px] bg-gray-300 opacity-60 rounded shadow-sm"></div>
    </div>
  )} */}

    <div className="hidden md:flex col-span-2 items-center justify-between">
      <div className="w-[45%] h-[1.5px] bg-gray-300 opacity-60 rounded shadow-sm"></div>
      <div className="w-[45%] h-[1.5px] bg-gray-300 opacity-60 rounded shadow-sm"></div>
    </div>

  {/* 3 - Chat with profiles (move up if horoscope is hidden) */}
  <div className={`flex flex-col gap-2`}>
    <div className="flex items-center gap-2">
      <img className="h-[3rem] w-[3rem] xl:h-[3.5rem] xl:w-[5.5rem] object-contain" src={ChatProfile} alt="" />
      <div className="flex flex-col">
        <p className="font-semibold text-[14px] xl:text-[15px] text-[#646464]">Chat with profiles</p>
        <p className='text-[12px] text-left text-[#646464] max-w-[288px] xl:text-[12px]'>
          Chat and connect instantly with your matches. Send personalized messages to build meaningful connections.
        </p>
      </div>
    </div>
    <div className="md:hidden h-[1px] bg-gray-300 opacity-60 rounded"></div>
  </div>

  {/* 4 - WhatsApp */}
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <img className="h-[3rem] w-[3rem] xl:h-[3.5rem] xl:w-[5.5rem] object-contain" src={WhatsappProfile} alt="" />
      <div className="flex flex-col">
        <p className="font-semibold text-[14px] xl:text-[15px] text-[#646464]">Get matches on WhatsApp!</p>
        <p className="text-[12px] text-left text-[#646464] max-w-[288px] xl:text-[12px]">
          Receive suitable profiles right on your WhatsApp.
        </p>
      </div>
    </div>
  </div>
</div>




                    </div>


            </div>
           
{/* Desktop View Button */}
<div className="hidden md:flex justify-center">
  <button
   
     onClick={onPayNow}
    className="mx-auto flex items-center cursor-pointer justify-center my-1 h-[1.5rem] text-white bg-[#D10A11] border border-[#D10A11] px-[2.3rem] lg:px-[2.8rem] whitespace-nowrap rounded-[50px] font-segoe font-semibold py-[1rem] lg:py-4 text-[12px]"
  >
    <OverflowToolTip as='p' className='truncate md:w-auto w-[15rem]'>
      Buy a Pack and Call Now!
    </OverflowToolTip>
  </button>
</div>

          </div>
        </div>
      </div>



      
      <div className="md:hidden fixed bottom-0 left-0 right-0 w-full bg-white px-4 py-3 border-t shadow-md z-50">
  <button
   
     onClick={onPayNow}
    className="w-full bg-[#D10A11] text-white font-semibold text-base py-3 rounded-full"
  >
    <OverflowToolTip as='p' className='truncate text-center w-full'>
      Buy a Pack and Call Now!
    </OverflowToolTip>
  </button>
</div>
    </div>
    
  );
};

export {PaymentCLCPopup,PaymentCLCBigPopup}; 